module.exports = __webpack_public_path__ + "media/images/products/gv500ma/gv500ma-1-200x200-376a50aa2dc393c053134d8abedd206e.png";